/* BUDOUCÍ MAJETEK (DĚDICTVÍ) — „Majetek k budoucímu prodeji".
 * ============================================================================
 * Majitel 29. 9. 2026: u dědictví chce vybrat typ (nemovitost po rodičích /
 * jiné) a hodnotu. Patří do NEFINANČNÍHO majetku, ale klient ho DNES nemá —
 * proto se:
 *   • NEPOČÍTÁ do dnešního čistého jmění ani do zdrojů na cíle,
 *   • v součtech a grafech ukazuje zvlášť s nálepkou
 *     „v budoucnu — zatím se nepočítá".
 * Kdyby se sčítal, poradce by klientovi ukázal čisté jmění včetně chalupy,
 * kterou zdědí za dvacet let, a plán by s ní počítal jako s penězi dnes.
 *
 * ZÁSTAVA: když je zadaná nemovitost po rodičích, analýza ji u cíle Bydlení
 * (nebo cíle na úvěr) NABÍDNE jako možnou zástavu. Je to jen informace
 * a volba poradce (`cil.zastavaId`) — žádný výpočet navíc se z ní nedělá.
 *
 * Data: řádky zůstávají v `majetek.dedictvi` (klíče se nemění, propsání do
 * složky klienta je bere jako dosud). Typ nese nové pole `druhDedictvi` —
 * schválně ne `typ`, to u nefinančního majetku znamená něco jiného
 * (nefinancni.js) a do složky by se propsalo jako neznámý typ.
 */

import { asArr, asObj } from "@/lib/bezpecneHodnoty";
import { jeHypotecniTypu } from "./cileTyp";

export const DEDICTVI_NEMOVITOST = "nemovitost_rodice";
export const DEDICTVI_JINE = "jine";
export const DRUHY_DEDICTVI = [DEDICTVI_NEMOVITOST, DEDICTVI_JINE];

const num = (v) => (Number.isFinite(+v) ? +v : 0);
const txt = (v) => String(v ?? "").trim();

/** Součet budoucího majetku (dědictví). Do čistého jmění NEVSTUPUJE. */
export function soucetBudoucihoMajetku(majetek) {
  return asArr(asObj(majetek).dedictvi).reduce((a, r) => a + num(r?.hodnota), 0);
}

/**
 * Data analýzy BEZ budoucího majetku — pro výpočty „dnes" (čisté jmění,
 * zdroje), které o dědictví nic nevědí. Nic nemaže: vrací kopii.
 */
export function bezBudoucihoMajetku(d) {
  const dd = asObj(d);
  const m = asObj(dd.majetek);
  if (!asArr(m.dedictvi).length) return dd;
  return { ...dd, majetek: { ...m, dedictvi: [] } };
}

/** Řádek dědictví, který je nemovitostí po rodičích a poradce ho vyplnil. */
export const jeNemovitostKZastave = (r) =>
  !!r && r.druhDedictvi === DEDICTVI_NEMOVITOST && (num(r.hodnota) > 0 || !!txt(r.oznaceni));

/** Nemovitosti z dědictví, které jde nabídnout jako zástavu. */
export function nemovitostiKZastave(d) {
  return asArr(asObj(asObj(d).majetek).dedictvi).filter(jeNemovitostKZastave);
}

/**
 * Nabízet u cíle zástavu? JEN u BYDLENÍ (a rekonstrukce) — tam jde o hypotéku.
 * Majitel 14. 10. 2026 (u cíle Auto na úvěr): „když je tam zástava, nemůže
 * být na dům z dědictví — to bude spotřebák nebo úvěr ze stavebka“. Plán to
 * tak počítá už od 5. 10. (karta cíle: u spotřebitelského úvěru / stavebka se
 * zástava nenabízí — DofinancovaniCile `spotr`), analýza se teď shoduje.
 */
export function nabiziZastavu(cil) {
  if (!cil || cil.mesicne) return false;
  return jeHypotecniTypu(cil.typ);
}
